import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Avatar} from 'antd';
import styles from './index.module.less';

export default function SphfeedCard({sphfeed}) {
    let {feed_type, sph_name, feed_desc} = sphfeed;
    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <div className={styles.title}>{sph_name}</div>
                <div className={styles.type}>
                    {feed_type === 2 && '(图片)'}
                    {feed_type === 4 && '(视频)'}
                    {feed_type === 9 && '(直播)'}
                </div>
            </div>
            <Divider style={{margin: '20px 0'}} />
            <div className={styles.foot}>{feed_desc}</div>
        </div>
    );
}

SphfeedCard.propTypes = {
    sphfeed: PropTypes.object,
};
